import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import WhiteboardCanvas from './WhiteboardCanvas';

const Whiteboard = ({
    backgroundImage,
    showWhiteboard,
    activeTool,
    color,
    thickness,
    canvasRef,
    onUnsavedChanges,
    setToolbarExpanded,
    onColorUsed,
}) => {
    // Cleanup when toggled OFF
    useEffect(() => {
        if (!showWhiteboard && canvasRef.current) {
            canvasRef.current.dispose();
            canvasRef.current = null;
        }
    }, [showWhiteboard]);

    // Detect if user has drawn anything new (possible for changes in the future)
    useEffect(() => {
        if (canvasRef.current) {
            const handleObjectAdded = () => {
                if (onUnsavedChanges) onUnsavedChanges(true);
            };
            const handleObjectRemoved = () => {
                if (onUnsavedChanges) onUnsavedChanges(true);
            };

            canvasRef.current.on('object:added', handleObjectAdded);
            canvasRef.current.on('object:removed', handleObjectRemoved);

            return () => {
                if (canvasRef.current) {
                    canvasRef.current.off('object:added', handleObjectAdded);
                    canvasRef.current.off('object:removed', handleObjectRemoved);
                }
            };
        }
    }, [canvasRef, onUnsavedChanges]);

    return (
        <div
            className={`whiteboard-container ${showWhiteboard ? 'active' : ''}`}
            style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                pointerEvents: showWhiteboard ? 'auto' : 'none',
                zIndex: showWhiteboard ? 999 : 10,
                background: 'transparent',
            }}
        >
            {/* Canvas aligned with the main illustration */}
            {showWhiteboard && (
                <Box
                    className="whiteboard-canvas-wrapper"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 5,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        pointerEvents: 'auto',
                    }}
                >
                    <WhiteboardCanvas
                        canvasRef={canvasRef}
                        setToolbarExpanded={setToolbarExpanded}
                        backgroundImage={backgroundImage}
                        activeTool={activeTool}
                        color={color}
                        thickness={thickness}
                        onColorUsed={onColorUsed}
                    />
                </Box>
            )}
        </div>
    );
};

export default Whiteboard;
